var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#333333;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st0",
    d: "M28.5,52.3h4.3v4.3h-4.3c-6.5,0-13-7.3-13-15.2s6.7-15.2,13-15.2h17.3c6.3,0,13,7.3,13,15.2 c0,6.1-3.9,11.8-8.7,14.1v-5c2.5-1.9,4.3-5.5,4.3-9.1c0-5.5-4.4-10.8-8.7-10.8H28.5c-4.2,0-8.7,5.3-8.7,10.8S24.2,52.3,28.5,52.3z  M67.5,39.3h-4.3v4.3h4.3c4.3,0,8.7,5.3,8.7,10.8s-4.4,10.8-8.7,10.8H50.2c-4.2,0-8.7-5.3-8.7-10.8c0-3.6,1.8-7.1,4.3-9.1v-5 c-4.7,2.3-8.7,8-8.7,14.1c0,7.8,6.7,15.2,13,15.2h17.3c6.3,0,13-7.3,13-15.2S74,39.3,67.5,39.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.378939fd3d6456a2fc5a9dd091d888f6.svg";
export { ForwardRef as ReactComponent };